import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Button, Modal } from "react-bootstrap";
import "./Css/IPassModule.css";
import GreyArrow from "../assets/greyLeftAr.png";
import Header from "./Header.js";
import {
  server_post_data,
  get_ipass_toll_unused_data,
  update_manual_toll_status,
} from "../ServiceConnection/serviceconnection.js";
import {
  goBack,
  handleError,
  handleSuccess,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";
import Select from "react-select";
const UnassignedTolls = ({ showSection }) => {
  // Dummy data for I-Passes
  const [ipassData, setIpassData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [noteViewModalOpen, setViewNoteModalOpen] = useState(false);
  const [hideButtons, setHideButtons] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDriverID, setSelectedDriverId] = useState("");
  const [statusNotes, setStatusNotes] = useState("");
  const [bookingIdToToggle, setBookingIdToToggle] = useState(null);
  const [driverData, setdriverData] = useState([]);

  useEffect(() => {
    master_data_get(0);
  }, []);

  const master_data_get = async (call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", call_id);
    fd.append("flags", "unusedtool");
    await server_post_data(get_ipass_toll_unused_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setIpassData(Response.data.message.data);
          setdriverData(Response.data.message.driver_data);
          console.log(Response.data.message);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Add these state variables after other useState declarations
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);

  // Add this pagination logic after your filter handlers
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    ipassData && ipassData?.length > 0
      ? ipassData.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  const totalPages =
    ipassData && ipassData.length > 0
      ? Math.ceil(ipassData.length / itemsPerPage)
      : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const statusData = [
    { value: "1", label: "Harsh Rane - 01" },
    { value: "2", label: "Anirban Panja - 02" },
    { value: "3", label: "Rohan Yadav - 03" },
    { value: "4", label: "Harsh Rane - 04" },
    { value: "5", label: "Anirban Panja - 05" },
    { value: "6", label: "Rohan Yadav - 06" },
    { value: "7", label: "Harsh Rane - 07" },
  ];

  const openStatusModal = (Id) => {
    setAssignModalOpen(true);
    setBookingIdToToggle(Id);
  };

  const openNoteStatusModal = (Id) => {
    setNoteModalOpen(true);
    setBookingIdToToggle(Id);
    setHideButtons(true);
  };

  const toggleNewStatus = async (flag) => {
    // }
    console.log(flag);
    let fd_from = new FormData();
    // Assign Toll to booking
    if (flag == 0 && selectedDriverID != "") {
      fd_from.append("call_id", bookingIdToToggle);
      fd_from.append("office_use_notes", statusNotes);
      fd_from.append("manual_status", 1);
      fd_from.append("driver_id", selectedDriverID);
    } else if (flag == 1 && statusNotes != "") {
      fd_from.append("call_id", bookingIdToToggle);
      fd_from.append("office_use_notes", statusNotes);
      fd_from.append("manual_status", 2);
    } else if (flag == 1 && statusNotes == "") {
      alert("Please fill the notes section, It cannot be empty");
      return;
    } else {
      alert("Please select a Driver");
      return;
    }

    await server_post_data(update_manual_toll_status, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setAssignModalOpen(false);
          setNoteModalOpen(false);
          master_data_get(0);
          handleSuccess(Response.data.message);
          setSelectedStatus("");
          setStatusNotes("");
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const toggleNewStatusModal = async () => {
    setNoteModalOpen(false);
    setHideButtons(false);
  };

  const options =
    driverData?.map((driver) => ({
      value: driver.primary_id,
      label: `${driver.name} - ${driver.primary_id}`,
    })) || [];

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="ipass-container container-fluid p-0">
        {/* Header Section */}
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <p className="breadcrumb-item">Unassigned Tolls</p>

            <img
              src={GreyArrow || "/placeholder.svg"}
              alt="Rapid Car Leasing"
            />
          </div>
          <Button onClick={goBack} className="Back_bttn_page">
            <ArrowLeft size={17} style={{ marginBottom: "2px" }} /> Back
          </Button>
        </div>

        {/* Table Section */}
        <div className="card ipass-card ipass-table-card mb-4">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover ipass-table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Entry Date</th>
                    <th>I-Pass No.</th>
                    <th>Car No.</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Exit Date</th>
                    <th>Posting Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems &&
                    currentItems.length > 0 &&
                    currentItems.map((ipass, index) => (
                      <tr key={ipass.id}>
                        <td style={{ fontSize: "14px" }}>
                          {indexOfFirstItem + index + 1}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {mondayDayYearFormat(ipass.entry_date)}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {ipass.ipass_tagid}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {ipass.ipass_car_no}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          ${ipass.ipass_amount}
                        </td>
                        <td style={{ fontSize: "14px" }}>{ipass.ipass_type}</td>
                        <td style={{ fontSize: "14px" }}>
                          {mondayDayYearFormat(ipass.ipass_exit_date)}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {mondayDayYearFormat(ipass.ipass_posting_date)}
                          {console.log(ipass.ipass_posting_date)}
                          {console.log(
                            "NAnna",
                            mondayDayYearFormat(ipass.ipass_posting_date)
                          )}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          <div
                            className="actioniconstest"
                            style={{ gap: "1rem", width: "60%" }}
                          >
                            {/* {!hideButtons ? (
                              <> */}
                            <button
                              className="tbnWhiteNew"
                              type="button"
                              style={{
                                whiteSpace: "nowrap",
                                fontSize: "13px",
                              }}
                              onClick={() => openStatusModal(ipass.primary_id)}
                            >
                              Allocate Toll
                            </button>
                            <button
                              className="tbnWhiteNew"
                              type="button"
                              style={{
                                whiteSpace: "nowrap",
                                fontSize: "13px",
                              }}
                              onClick={() =>
                                openNoteStatusModal(ipass.primary_id)
                              }
                            >
                              Add Note
                            </button>
                            {/* </>
                            ) : (
                              <button
                                className="tbnWhiteNew"
                                type="button"
                                style={{
                                  whiteSpace: "nowrap",
                                  fontSize: "13px",
                                }}
                                onClick={() => openNoteViewModal("1")}
                              >
                                View Note
                              </button>
                            )} */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {ipassData && ipassData.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, ipassData.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {ipassData.length}
                    </span>{" "}
                    I-Passes
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    I-Passes
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Toll assign modal */}
      <Modal
        show={assignModalOpen}
        onHide={() => setAssignModalOpen(false)}
        className="ipass-modal"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>
            Allocate Toll to Booking
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="assignForm">
            <div className="mb-3">
              <label
                htmlFor="selectVehicle"
                className="form-label ipass-form-label"
              >
                Select Driver
              </label>
              {/* <select
                id="selectVehicle"
                name="vehicleId"
                className="form-select"
                required
                onChange={(e) => {
                  setSelectedDriverId(e.target.value);
                  console.log(e.target.value);
                }}
              >
                <option value="" disabled selected>
                  -- Select a Driver --
                </option>
                {driverData &&
                  driverData.length > 0 &&
                  driverData.map((vehicle, idx) => (
                    <option key={idx} value={vehicle.primary_id}>
                      {vehicle.name} - {vehicle.primary_id}
                    </option>
                  ))}
              </select> */}
              <Select
                options={options}
                onChange={(selected) => setSelectedDriverId(selected?.value)}
                placeholder="-- Select a Driver --"
                isSearchable
                required
                id="selectVehicle"
                name="vehicleId"
                // className="form-select"
              />
            </div>
            <div className="mb-3">
              <label
                htmlFor="assignmentNotes"
                className="form-label ipass-form-label"
              >
                Notes (Optional)
              </label>
              <textarea
                id="assignmentNotes"
                name="notes"
                rows="3"
                className="form-control"
                placeholder="Add any additional information about this assignment"
                onChange={(e) => setStatusNotes(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAssignModalOpen(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
              color: "#ffffff",
            }}
            onClick={() => toggleNewStatus(0)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toll add note assign modal */}
      <Modal
        show={noteModalOpen}
        onHide={() => setNoteModalOpen(false)}
        className="ipass-modal"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>Add Note to Toll</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="assignForm">
            <div className="mb-3">
              <label
                htmlFor="assignmentNotes"
                className="form-label ipass-form-label"
              >
                Notes
              </label>
              <textarea
                id="assignmentNotes"
                name="notes"
                rows="3"
                className="form-control"
                placeholder="Add any additional information about this assignment"
                onChange={(e) => setStatusNotes(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setNoteModalOpen(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
              color: "#ffffff",
            }}
            onClick={() => toggleNewStatus(1)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UnassignedTolls;
